import Cookie from 'js-cookie';

(function() {
  // Set the age of the cookies in days
  const COOKIE_AGE = 90; // 90 days
  const CLICK_IDS = ['gclid', 'msclkid', 'fbclid'];

  function getCurrentTimestamp() {
    return Math.floor(Date.now() / 1000);
  }

  function getMainDomain() {
    const parts = location.hostname.split('.');
    if (parts.length > 2) parts.shift();
    return parts.join('.');
  }

  function setCookie(name, value) {
    Cookie.set(name, value, {
      expires: COOKIE_AGE,
      domain: getMainDomain(),
      path: '/',
      sameSite: 'Lax',
      secure: location.protocol === 'https:'
    });
  }

  function getCookie(name) {
    return Cookie.get(name);
  }

  // Buffer URL click-ids (mag zonder consent)
  (function bufferClickIdsFromUrl() {
    const params = new URLSearchParams(location.search);
    CLICK_IDS.forEach((name) => {
      const v = params.get(name);
      if (v) sessionStorage.setItem(name, v);
    });
  })();

  async function maybeInitFbcIfNeeded(fbclid) {
    try {
      if ('cookieStore' in window) {
        const fbc = await window.cookieStore.get('_fbc');
        if (!fbc?.value) setCookie('_fbc', `fb.2.${getCurrentTimestamp()}.${fbclid}`);
      } else {
        if (!getCookie('_fbc')) setCookie('_fbc', `fb.2.${getCurrentTimestamp()}.${fbclid}`);
      }
    } catch {
      if (!getCookie('_fbc')) setCookie('_fbc', `fb.2.${getCurrentTimestamp()}.${fbclid}`);
    }
  }

  function persistBufferedClickIds() {
    CLICK_IDS.forEach((name) => {
      const value = sessionStorage.getItem(name);
      if (!value) return;
      setCookie(name, value);
      if (name === 'fbclid') {
        maybeInitFbcIfNeeded(value);
      }
    });
  }

  // Consent checks for both Cookiebot and the new cookie banner
  function hasAdsConsentFromCookieBot() {
    if (window.Cookiebot?.consent?.marketing === true) return true;

    // Some setups use window.CookieConsent
    if (window.CookieConsent?.consent?.marketing === true) return true;
    return false;
  }

  function hasAdsConsentFromNewBannerObject(obj) {
    // New banner object (gtag consent schema)
    return obj?.ad_storage === 'granted' || obj?.ad_user_data === 'granted';
  }

  function hasAdsConsentFromNewBannerCookies() {
    // Cookies set by new banner
    const overall = getCookie('cookie-consent');
    const marketing = getCookie('marketing-cookies');
    return overall === 'granted' && marketing === 'granted';
  }

  function hasAdsConsentFromCookieConfirm(categories) {
    // CookieConfirm exposes the accepted categories; 'marketing' == ads consent
    return Array.isArray(categories) && categories.includes('marketing');
  }

  function getCookieConfirmCategories() {
    // Cookie value is a JSON array of accepted categories, e.g. ["functional","marketing"]
    try {
      return JSON.parse(getCookie('CC_p_accepted_cookies') || '[]');
    } catch {
      return [];
    }
  }

  function hasAdsConsentFromCookieConfirmCookie() {
    return hasAdsConsentFromCookieConfirm(getCookieConfirmCategories());
  }

  function hasAdsConsentNow() {
    // Combine all supported consent managers
    return hasAdsConsentFromCookieBot()
      || hasAdsConsentFromNewBannerCookies()
      || hasAdsConsentFromCookieConfirmCookie();
  }

  // === Direct check on page load ===
  if (hasAdsConsentNow()) {
    persistBufferedClickIds();
  }

  // Listeners for Cookiebot ===
  // Fire on initialization and on accept again
  window.addEventListener('CookiebotOnConsentReady', () => {
    if (hasAdsConsentFromCookieBot()) persistBufferedClickIds();
  }, false);
  window.addEventListener('CookiebotOnAccept', () => {
    if (hasAdsConsentFromCookieBot()) persistBufferedClickIds();
  }, false);

  // Listeners for new banner ===
  // 1) Strong hook: addConsentListener (after mount of <cookie-consent-banner>)
  if (typeof window.addConsentListener === 'function') {
    window.addConsentListener((consentObj) => {
      if (hasAdsConsentFromNewBannerObject(consentObj)) {
        persistBufferedClickIds();
      }
    });
  }
  // 2) Safety net: custom events
  window.addEventListener('ConsentAccepted', (ev) => {
    if (hasAdsConsentFromNewBannerObject(ev.detail)) {
      persistBufferedClickIds();
    }
  });

  // Listeners for CookieConfirm (cookieconfirm.com) ===
  // `consentEnabled` fires both on fresh accept and on reload with stored
  // consent; ev.detail is the array of accepted categories. Subscribe via
  // addEventListener (not window.ccListen) so load order does not matter —
  // consent.js loads async via GTM, after this script.
  window.addEventListener('consentEnabled', (ev) => {
    if (hasAdsConsentFromCookieConfirm(ev.detail)) {
      persistBufferedClickIds();
    }
  });

//   Not sure if we want this yet..
//   window.addEventListener('ConsentDeclined', () => {
//     CLICK_IDS.forEach((n) => Cookie.remove(n, { domain: getMainDomain(), path: '/' }));
//     Cookie.remove('_fbc', { domain: getMainDomain(), path: '/' });
//   });

})();
